// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// Fuse
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components';
// Loader
import { NgxUiLoaderModule } from 'ngx-ui-loader';
// Translate
import { TranslateModule } from '@ngx-translate/core';
// Local component
import { AddComponent } from './main/add/add.component';
import { HeaderAddComponent } from './main/add/header-add/header-add.component';
import { HeaderComponent } from './main/header/header.component';
import { MainComponent } from './main/main.component';
import { TableComponent } from './main/table/table.component';
// Common component
import { CommonComponentModule } from '../common-component/common-component.module';
// Guard
import { AuthGuardService as AuthGuard } from '../oauth/auth-guard.service';
// Material
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

const routes = [
  {
    path: 'main',
    data: {breadcrumb: 'Admin. Distribución'},
    children: [
      {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        data: {breadcrumb: 'Distribuciones'},
      },
      {
        path: 'configuration/:complexId/:propertyId',
        component: AddComponent,
        canActivate: [AuthGuard],
        data: {breadcrumb: 'Configuración de espacio'},
      },
    ]
  },
];

@NgModule({
  declarations: [
    AddComponent,
    HeaderAddComponent,
    HeaderComponent,
    MainComponent,
    TableComponent,
  ],
  imports: [
    RouterModule.forChild(routes),
    // Translate
    TranslateModule,
    // Loader
    NgxUiLoaderModule,
    // Fuse
    FuseSharedModule,
    FuseWidgetModule,
    // Common component
    CommonComponentModule,
    // Material
    MatButtonModule,
    MatCardModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
  ],
    exports: [
        MainComponent,
    ],
})
export class DistributionModule { }
